export const API_URL = process.env.VUE_APP_BASE_URL
export const API_URL_VIEW = process.env.VUE_APP_BASE_URL_VIEW

export default {
  API_URL,
  API_URL_VIEW,
};
